(function () {
  function collapseItem(item, trigger, collapse) {
    if (!item || !trigger || !collapse || !item.classList.contains("faq__item--expanded")) {
      return;
    }

    item.classList.remove("faq__item--expanded");
    trigger.setAttribute("aria-expanded", "false");

    collapse.addEventListener("transitionend", function onClose(event) {
      if (event.propertyName !== "grid-template-rows") {
        return;
      }

      if (!item.classList.contains("faq__item--expanded")) {
        collapse.hidden = true;
      }

      collapse.removeEventListener("transitionend", onClose);
    });
  }

  function expandItem(item, trigger, collapse) {
    collapse.hidden = false;
    item.classList.add("faq__item--expanded");
    trigger.setAttribute("aria-expanded", "true");
  }

  function initFaqPanel(panel) {
    var list = panel.querySelector(".faq__list");
    var moreBtn = panel.querySelector(".faq__more");

    if (list) {
      list.addEventListener("click", function (event) {
        var trigger = event.target.closest(".faq__trigger");

        if (!trigger || !list.contains(trigger)) {
          return;
        }

        var item = trigger.closest(".faq__item");
        var collapse = item.querySelector(".faq__collapse");

        if (!collapse) {
          return;
        }

        if (item.classList.contains("faq__item--expanded")) {
          collapseItem(item, trigger, collapse);
          return;
        }

        list.querySelectorAll(".faq__item--expanded").forEach(function (openItem) {
          collapseItem(
            openItem,
            openItem.querySelector(".faq__trigger"),
            openItem.querySelector(".faq__collapse")
          );
        });

        expandItem(item, trigger, collapse);
      });
    }

    if (moreBtn) {
      moreBtn.addEventListener("click", function () {
        panel.querySelectorAll(".faq__item--hidden").forEach(function (item) {
          item.classList.remove("faq__item--hidden");
        });

        panel.classList.add("faq__panel--expanded");
      });
    }
  }

  document.querySelectorAll(".faq__panel").forEach(initFaqPanel);
})();
